import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("pwa_prompt_dismissed");
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem("pwa_prompt_dismissed", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:w-80 z-40 bg-white border border-zinc-200 p-4 shadow-lg" data-testid="pwa-install-prompt">
      <button onClick={dismiss} className="absolute top-2 right-2 text-zinc-400 hover:text-zinc-900" data-testid="pwa-dismiss-btn">
        <X size={14} strokeWidth={1.5} />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-[#002FA7] flex items-center justify-center flex-shrink-0">
          <Download size={18} strokeWidth={1.5} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display text-base tracking-tight mb-1">Install Jastip-Safe</div>
          <p className="text-xs text-zinc-600 mb-3">Add to your home screen for faster access and offline support.</p>
          <button onClick={install} className="btn-primary-flat text-xs !py-2 !px-3 w-full" data-testid="pwa-install-btn">
            Install App
          </button>
        </div>
      </div>
    </div>
  );
}
